
import { computed, onMounted, ref } from 'vue';
import Button from 'primevue/button';
import Message from 'primevue/message';
import { game } from '../apis/game';
import { GamesList, GameStatusResult } from '../types/game';
import GameNavbar from '../components/navbar/GameNavbar.vue';

import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { showVuePopup } from '../utils/showVuePopup';
import Login from '../popup/Login.vue';
import { useToast } from 'primevue/usetoast';
import { openGameUrl } from '../utils/openGameUrl';

export default {
	name: 'Sport',
	components: {
		IconField,
		InputIcon,
		InputText,
		Button,
		Message,
		GameNavbar,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		onMounted(async () => {
			await handleGameStatus();
			await handleProducts();
		});

		const error = ref<string | null>(null);
		const loadingProducts = ref(true);

		const gameState = ref<GameStatusResult>({
			card: false,
			casino: false,
			cock: false,
			esport: false,
			fish: false,
			keno: false,
			lotto: false,
			poker: false,
			slot: false,
			sport: false,
			trade: false,
		});

		// เพิ่ม type ช่วยให้ชัดเจน
		type GameItem = GamesList & { gameType: number; productCode: string };

		const selectedProduct = ref<GamesList>();
		const products = ref<GamesList[]>([]);
		const searchQuery = ref('');

		const filteredProducts = computed(() => {
			return products.value.filter((product) =>
				product.productName?.toLowerCase().includes(searchQuery.value.toLowerCase())
			);
		});

		const handleGameStatus = async () => {
			try {
				const resp = await game.status();
				if (resp.code !== '0') throw new Error(resp.message);
				gameState.value = resp.result as GameStatusResult;
			} catch (err: any) {
				error.value = err.message;
			}
		};

		const handleProducts = async () => {
			loadingProducts.value = true;
			error.value = null;

			try {
				// เดิมพันกีฬาเปิดให้บริการเฉพาะ Ibcbet (SABA) — ค่ายอื่นปิดอยู่ ผู้เล่นเข้าไม่ได้
				// จึงคอมเมนต์ไว้แทนการลบ เพื่อให้เปิดกลับได้โดยไม่ต้องไปค้น gameType ใหม่
				const reqs = [
					// { gameType: 11, productCode: 'SBO' },
					{ gameType: 12, productCode: 'SABA' },
					// { gameType: 13, productCode: 'DBS' },
					// { gameType: 14, productCode: 'FBS' },
					// { gameType: 15, productCode: 'PLB' },
					// { gameType: 16, productCode: 'UMB' },
					// { gameType: 17, productCode: 'VBS' },
					// { gameType: 18, productCode: 'AFB' },
					// { gameType: 19, productCode: 'LALI' },
					// { gameType: 20, productCode: 'WSS' },
					// { gameType: 21, productCode: 'M9' },
					// { gameType: 22, productCode: 'UFA' },
				];

				const responses = await Promise.all(reqs.map(d => game.listByCode(d)));

				products.value = responses.flatMap((res, idx) => {
					const gt = reqs[idx].gameType;
					const pc = reqs[idx].productCode;
					const list: GamesList[] = res.result?.gamesList || [];
					return list.map(g => ({ ...g, gameType: gt, productCode: pc } as GameItem));
				});
			} catch (err: any) {
				error.value = err.message;
			} finally {
				loadingProducts.value = false;
			}
		};

		const handleFavoriteAdd = async (code: string) => {
			try {
				const resp = await game.favoriteAdd(code);
				if (resp.code !== '0') throw new Error(resp.message);

				toast.add({
					severity: 'success',
					summary: resp.message,
					detail: 'เพิ่มลงรายการโปรดสำเร็จ',
					life: 3000,
				});
			} catch (err: any) {
				error.value = err.message;
			}
		};

		const handleFavoriteRemove = async (code: string) => {
			try {
				const resp = await game.favoriteDelete(code);
				if (resp.code !== '0') throw new Error(resp.message);

				toast.add({
					severity: 'success',
					summary: resp.message,
					detail: 'ลบรายการโปรดสำเร็จ',
					life: 3000,
				});
			} catch (err: any) {
				error.value = err.message;
			}
		};

		const clickGame = async (code: string, gameType: number) => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login, {}, {
					customClass: {
						popup: 'bg-[url(https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/bg-login-main.webp)] bg-size-[110%_100%] bg-center bg-transparent',
					},
				});
				return;
			}

			const found = products.value.find((p) => p.loginCode === code);
			if (found) {
				selectedProduct.value = found;

				try {
					const payload = {
						gameType: gameType,
						productCode: found.productCode,
						code: code,
						redirect: window.location.origin,
						isMobile: true,
					};
					const resp = await game.login(payload);
					if (resp.code !== '0') throw new Error(resp.message);

					openGameUrl(resp?.url || window.location.origin, (target) => window.location.replace(target));
				} catch (err: any) {
					alert(err);
				}
			}
		};

		const clickSport = async () => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login);
				return;
			}

			try {
				const payload = {
					redirect: window.location.origin,
				};
				const resp = await game.sport(payload);
				if (resp.code !== '0') throw new Error(resp.message);

				openGameUrl(resp?.urlMobileProduct || window.location.origin, (target) => window.location.replace(target));
			} catch (err: any) {
				error.value = err.message;
			}
		}

		const clickBtnFavorite = async (code: string, actionOld: boolean) => {
			try {
				if (actionOld) {
					await handleFavoriteRemove(code);
				} else {
					await handleFavoriteAdd(code);
				}
			} catch (err: any) {
				error.value = err.message;
			} finally {
				await handleProducts();
			}
		};

		return {
			auth,
			filteredProducts,
			searchQuery,
			selectedProduct,
			clickGame,
			clickSport,
			clickBtnFavorite,
			error,
			loadingProducts,
		};
	},
};
